import React from 'react';
import DialogModal from 'dashboard/layouts/auth/types/popup';
import CreateBrandForm from './CreateBrandForm';

/**
 * "Create Brand" dialog.
 *
 * Thin shell: the modal chrome lives in DialogModal, the two fields and their
 * submit live in CreateBrandForm. Editing an existing brand is a different
 * surface entirely (brand Settings → InformationDetails).
 */
const CreateModal = (props) => {
  const { fetchBrands, add, setShowCreateModal, onBrandCreated } = props;

  /**
   * Whether this dialog can actually be dismissed.
   *
   * `add` alone used to decide whether the close button appeared, while
   * closing depended on a `setShowCreateModal` the caller might not have
   * passed — and one caller did not. The X rendered and did nothing.
   *
   * Tying the button to the ability rather than to the intent means a dead
   * close button cannot happen again: no closer, no button.
   */
  const canClose = Boolean(add) && typeof setShowCreateModal === 'function';
  const close = () => setShowCreateModal(false);

  const handleCreated = (newBrandId) => {
    if (canClose) close();
    // Prefer the caller's handler — it selects the new brand AND routes to its
    // overview. fetchBrands alone only refreshes the list.
    if (onBrandCreated) onBrandCreated(newBrandId);
    else if (fetchBrands) fetchBrands(newBrandId);
  };

  return (
    <DialogModal
      title='Create Brand'
      isOpenAction
      onCloseAction={canClose ? close : undefined}
      closedNotAllowed={!canClose}
      layout='flex'
      contentPadding={0}
      key='create'
    >
      <CreateBrandForm
        onCreated={handleCreated}
        onCancel={canClose ? close : undefined}
      />
    </DialogModal>
  );
};

export default CreateModal;
